import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=2fd0f6d2&scoped=true"
import script from "./PageTitleBar.vue?vue&type=script&lang=js"
export * from "./PageTitleBar.vue?vue&type=script&lang=js"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=2fd0f6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0f6d2",
  null
  
)

export default component.exports